import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import * as moment from 'moment';
import { AppUtils } from '../../../core/config/app.utils';
import { ReportsService } from '../../../core/services/reports.service';
import { FleetService } from '../../../core/services/fleet.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-generate-paging-board-popup',
  templateUrl: './generate-paging-board-popup.component.html',
  styleUrls: ['./generate-paging-board-popup.component.scss'],
})
export class GeneratePagingBoardPopupComponent implements OnInit {
  @Output() handleGeneratePagingBoardModalOnChange: EventEmitter<any> =
    new EventEmitter();
  @Input() isVisibleGeneratePagingBoardModal = false;
  @Input() pagingBoardData: any;

  pagingBoardForm: FormGroup | any;
  pagingBoardErrors: any;
  pagingBoardPdf: any;
  pdfLoading = false;
  loading = false;

  constructor(
    private fb: FormBuilder,
    private reportService: ReportsService,
    private fleetService: FleetService,
    private message: NzMessageService,
  ) {}

  ngOnInit() {
    this.initPagingBoardForm();
    this.setValues();
  }
  initPagingBoardForm() {
    this.pagingBoardForm = this.fb.group({
      customer: [null, [Validators.required, this.characterValidator]],
      date: [null, [Validators.required]],
      time: [null, [Validators.required]],
      flight: [null, [Validators.required]],
      dropLocation: [null],
      numOfPax: [null],
      // vehicleCategory: [{ value: null, disabled: true }],
      customerNumber: [
        null,
        [
          Validators.required,
          Validators.maxLength(15),
          Validators.pattern(/^\d+$/),
        ],
      ],
      agent: [{ value: null, disabled: true }],
    });
    this.pagingBoardErrors = {
      customer: {},
      date: {},
      time: {},
      flight: {},
      dropLocation: {},
      numOfPax: {},
      // vehicleCategory: {},
      customerNumber: {},
      agent: {},
    };
    this.pagingBoardForm.valueChanges.subscribe(() => {
      this.pagingBoardErrors = AppUtils.getFormErrors(
        this.pagingBoardForm,
        this.pagingBoardErrors,
      );
    });
  }
  characterValidator = (control: FormControl) => {
    const value = control.value;
    if (!value) {
      return { required: true };
    }
    const words = value.split(' ');
    if (words.length > 2 || words.find((v: string) => v.length > 15)) {
      return { wordLimit: true };
    }
    return {};
  };
  async setValues(): Promise<void> {
    this.loading = true;
    try {
      const data = await this.fleetService.getOneVehicleCat(
        this.pagingBoardData.vehicleCategory,
      );
      this.loading = false;
      this.pagingBoardForm.patchValue(this.pagingBoardData);
      this.pagingBoardForm
        .get('date')
        .patchValue(new Date(this.pagingBoardData.date));
      this.pagingBoardForm
        .get('time')
        .patchValue(new Date(this.pagingBoardData.time));
      this.pagingBoardForm.get('vehicleCategory').patchValue(data.name);
    } catch (e) {
      this.loading = false;
    }
  }

  isDirtyOrInvalid() {
    return this.pagingBoardForm.dirty || this.pagingBoardForm.invalid;
  }

  pagingBoardFormSave() {
    this.pagingBoardForm.markAsPristine();
    this.pagingBoardPdf = null;
  }

  async loadPagingBoard(type: string): Promise<void> {
    try {
      if (!this.pagingBoardPdf) {
        const payload = this.pagingBoardForm.getRawValue();
        payload.date = moment(payload.date).format('MMM Do YYYY').toString();
        payload.time = moment(payload.time).format('LT').toString();
        payload.type = this.pagingBoardData.type;
        payload.agent = payload.agent ? payload.agent : '-';
        this.pdfLoading = true;
        this.pagingBoardPdf =
          await this.reportService.generatePagingBoardReport([payload]);
        this.message.create('success', `PDF has been created!`);
        this.pdfLoading = false;
        this.pagingBoardAction(type);
      } else {
        this.pagingBoardAction(type);
      }
    } catch (e) {
      this.message.create('error', `Can't generate PDF`);
    }
  }

  pagingBoardAction(type: string) {
    switch (type) {
      case 'preview':
        this.reportService.viewReport(this.pagingBoardPdf);
        break;
      case 'download':
        this.reportService.downloadReport(this.pagingBoardPdf);
        break;
      case 'email':
        this.reportService.emailPdf();
        break;
      case 'print':
        this.reportService.printReport(this.pagingBoardPdf);
        break;
    }
  }

  handleCancelGeneratePagingBoardModal() {
    this.handleGeneratePagingBoardModalOnChange.emit({
      action: 'Invisible',
    });
    this.isVisibleGeneratePagingBoardModal = false;
    this.pagingBoardData = null;
    this.pagingBoardPdf = null;
  }
}
